import React from 'react';

import type { CustomGlyphProps } from '@atlaskit/icon/types';

export default (props: CustomGlyphProps) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M5.67114 13.88C5.67114 15.1422 4.64003 16.1734 3.37781 16.1734C2.11558 16.1734 1.08447 15.1422 1.08447 13.88C1.08447 12.6178 2.11558 11.5867 3.37781 11.5867C4.64438 11.5867 5.67114 12.6134 5.67114 13.88Z"
			fill="#E01E5A"
		/>
		<path
			d="M6.82672 13.88C6.82672 12.6178 7.85783 11.5867 9.12005 11.5867C10.3823 11.5867 11.4134 12.6178 11.4134 13.88V19.6222C11.4134 20.8844 10.3823 21.9156 9.12005 21.9156C7.85783 21.9156 6.82672 20.8844 6.82672 19.6222V13.88Z"
			fill="#E01E5A"
		/>
		<path
			d="M9.12005 4.67114C7.85783 4.67114 6.82672 3.64003 6.82672 2.37781C6.82672 1.11558 7.85783 0.0844727 9.12005 0.0844727C10.3823 0.0844727 11.4134 1.11558 11.4134 2.37781C11.4134 3.64438 10.3866 4.67114 9.12005 4.67114Z"
			fill="#36C5F0"
		/>
		<path
			d="M9.12003 5.82678C10.3823 5.82678 11.4134 6.8579 11.4134 8.12012C11.4134 9.38235 10.3823 10.4135 9.12003 10.4135H3.37781C2.11558 10.4135 1.08447 9.38235 1.08447 8.12012C1.08447 6.8579 2.11558 5.82678 3.37781 5.82678H9.12003Z"
			fill="#36C5F0"
		/>
		<path
			d="M18.3289 8.12012C18.3289 6.8579 19.36 5.82678 20.6223 5.82678C21.8845 5.82678 22.9156 6.8579 22.9156 8.12012C22.9156 9.38235 21.8845 10.4135 20.6223 10.4135C19.3557 10.4135 18.3289 9.3867 18.3289 8.12012Z"
			fill="#2EB67D"
		/>
		<path
			d="M17.1733 8.12004C17.1733 9.38227 16.1422 10.4134 14.88 10.4134C13.6178 10.4134 12.5867 9.38227 12.5867 8.12004V2.37781C12.5867 1.11559 13.6178 0.0844727 14.88 0.0844727C16.1422 0.0844727 17.1733 1.11559 17.1733 2.37781V8.12004Z"
			fill="#2EB67D"
		/>
		<path
			d="M14.88 17.329C16.1422 17.329 17.1733 18.3601 17.1733 19.6223C17.1733 20.8845 16.1422 21.9156 14.88 21.9156C13.6178 21.9156 12.5867 20.8845 12.5867 19.6223C12.5867 18.3557 13.6134 17.329 14.88 17.329Z"
			fill="#ECB22E"
		/>
		<path
			d="M14.88 16.1734C13.6178 16.1734 12.5867 15.1422 12.5867 13.88C12.5867 12.6178 13.6178 11.5867 14.88 11.5867H20.6222C21.8844 11.5867 22.9156 12.6178 22.9156 13.88C22.9156 15.1422 21.8844 16.1734 20.6222 16.1734H14.88Z"
			fill="#ECB22E"
		/>
	</svg>
);
